import Vue from "vue"
import Router from "vue-router"

Vue.use(Router)

export const routes = [
    {
        path: '/',
        component: () => import("@/views/home/home")
    },
    {
        path: '/teacher',
        name: "teacher",
        component: () => import("@/views/teacher/index")
    },
    {
        path: '/news',
        name: "news",
        component: () => import("@/views/news/index")
    },
    {
        path: "/detail/:id",
        name: "detail",
        component: () => import("@/views/news/detail")
    },
    {
        path: '/video',
        name: "video",
        component: () => import("@/views/video/index")
    },
    {
        path: '/major',
        name: "major",
        component: () => import("@/views/major/index")
    },
    {
        path: '/wine',
        name: "wine",
        component: () => import("@/views/wine/index")
    },
    {
        path: '/coffee',
        name: "coffee",
        component: () => import("@/views/coffee/index")
    },
    {
        path: '/bake',
        name: "bake",
        component: () => import("@/views/bake/index")
    },
    {
        path: '/westfood',
        name: "westfood",
        component: () => import("@/views/westfood/index")
    },
    {
        path: '/dataStatistics89sesef31d34df',
        name: "dataStatistics",
        component: () => import("@/views/tools/dataStatistics")
    },
]

const router = new Router({
    mode: "hash",/*  */
    base: process.env.BASE_URL,
    routes // (缩写) 相当于 routes: routes
})
export default router




